import React from 'react'
import {
    HeaderDegraded,
    HeaderDegradedLeft,
    HeaderImage,
    Image,
    OverHeader,
    OverLimit,
    TypographySpan,
    TypographySubTitle,
    TypographyTitle,
} from './styles'
import ImageHeader from 'src/assets/WereHiring/ImageToStl.com_image.avif'
import { useTranslations } from "src/provider/LocaleProvider";
export function Header() {
    const t = useTranslations()
    return (
        <OverHeader
            marginBottom={'xxxlarge'}
            marginTop={['xxxlarge', 'xxxlarge', 0, 0]}
        >
            <OverLimit>
                <HeaderDegraded
                    paddingTop={'xxxlarge'}
                    paddingLeft={['medium', 'medium', 'xxxsmall', 0]}
                >
                    <TypographyTitle
                        variant={'h2'}
                        fontSize={['small', 'small', 'medium', 'xxxmedium']}
                        fontWeight={400}
                    >
                        {t('worldWile.staircase.title')}
                    </TypographyTitle>
                    <TypographySubTitle
                        variant={'h1'}
                        fontSize={['xxxmedium', 'xxxmedium', 'xxlarge', 'eith']}
                        fontWeight={400}
                    >
                        {t('worldWile.staircase.subTitle')}
                    </TypographySubTitle>
                    <TypographySpan
                        variant={'h1'}
                        fontSize={['xxxmedium', 'xxxmedium', 'xxlarge', 'eith']}
                        fontWeight={700}
                    >
                        {t('worldWile.staircase.blurEffect')}
                    </TypographySpan>
                </HeaderDegraded>
                <HeaderImage>
                    <Image src={ImageHeader} alt={'ImageHeader'} />
                </HeaderImage>
                <HeaderDegradedLeft />
            </OverLimit>
        </OverHeader>
    )
}
